<template>
  <modal
    title="Save Comparison"
    :open="open"
    @close="closeModal"
  >
    <p class="description">
      Give your custom comparison a name.
    </p>
    <form @submit.stop.prevent="saveComparison">
      <text-input
        id="compare-name"
        ref="nameInput"
        v-model="name"
        type="text"
        label="Name"
        maxlength="40"
      />

      <div
        v-for="(item, i) in items"
        :key="i"
        class="comparison"
      >
        {{ item.label }}
      </div>

      <br />

      <div class="button-row">
        <btn
          type="submit"
          loading-text="Submitting"
          :loading="submitting"
          :disabled="disabled"
        >
          Save
        </btn>

        <btn kind="secondary" @click="closeModal">
          Cancel
        </btn>
      </div>
    </form>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import * as Sentry from '@sentry/vue';

import { authService } from '@/services';

export default {
  props: {
    open: Boolean,
    editing: Object,
    items: Array,
    type: String,
  },

  data() {
    return {
      name: '',
      submitting: false,
    };
  },

  watch: {
    open: {
      async handler(value) {
        if (value) {
          this.name = this.editing?.name || '';

          await this.$nextTick();
          this.$refs.nameInput.focus();
        }
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    disabled() {
      return !this.name;
    },
  },

  methods: {
    async saveComparison() {
      this.submitting = true;

      try {
        const items = (this.editing?.items || this.items)
          .map((item) => {
            const map = {
              id: item.id,
              label: item.label,
            };

            if (this.type === 'indexes' && Boolean(item.playerId)) {
              map.player = true;
            }

            return map;
          });

        const comparison = {
          id: this.editing?.id || null,
          name: this.name,
          items,
          type: this.type,
        };

        await authService.createOrUpdateComparison(this.user.uid, comparison);
        this.$toasted.success('Saved your comparison!');
        this.closeModal();
      } catch (e) {
        this.$toasted.error('Error saving your comparison');
        Sentry.captureException(e);
      }

      this.submitting = false;
    },

    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
